"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject, _templateObject2, _templateObject3;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  .Text {\n    margin-left: 1em;\n  }\n"])));
exports.InputWrapper = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border: ", ";\n  width: 15px;\n  color: ", ";\n  height: 15px;\n  border-radius: 100%;\n  cursor: pointer;\n"])), function (_ref) {
  var theme = _ref.theme,
    isSelected = _ref.isSelected;
  return isSelected ? theme.farmProject.green : null;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.farmProject.green);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.farmProject.gray_3;
});
exports.Input = styled_components_1.default.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 7px;\n  width: 7px;\n  margin: 0;\n  background-color: white;\n  border-radius: 50%;\n  border: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n"])));